import { apiBase } from '@/api/instance';
import Qs from 'qs';

export const SearchProduct = (params) => {
  return apiBase({
    url: `/products`,
    method: 'get',
    params: params,
    paramsSerializer: (params) => {
      return Qs.stringify(params, { arrayFormat: 'repeat' });
    }
  });
};

export const UploadImage = (formData) => {
  return apiBase({
    url: '/images/upload',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export const StoreProduct = (params) => {
  return apiBase({
    url: '/products',
    method: 'post',
    data: params
  });
};

export const ShowProduct = ({ id }) => {
  return apiBase({
    url: `/products/${id}`,
    method: 'get'
  });
};

export const UpdateProduct = (params) => {
  return apiBase({
    url: `/products/${params.id}`,
    method: 'put',
    data: params
  });
};

export const DestroyProduct = ({ id }) => {
  return apiBase({
    url: `/products/${id}`,
    method: 'delete'
  });
};
